<template>
  <b-modal
    ref="customCodeModal"
    hide-footer
    centered
    title="Update custom code"
    >
    <b-form @submit.prevent="update" novalidate>
      <b-form-group
        label="File name:"
        >
        <b-form-input
          ref="fileNameInput"
          type="text"
          autocomplete="off"
          v-model.trim="$v.fileName.$model"
          :class="{ 'is-invalid': $v.fileName.$error }"
          :disabled="inProgress"
          />
        <b-form-invalid-feedback v-if="!$v.fileName.required">File name is required</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Scope:"
        >
        <b-form-select v-model="selectedScope" :options="scopes" />
      </b-form-group>
      <b-button
        type="submit"
        >
        Update
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      inProgress: false,
      fileName: '',
      key: '',
      type: '',
      tabs: null,
      selectedScope: null,
      customCode: null
    }
  },
  computed: {
    scopes () {
      let scopes = [
        {
          value: null,
          text: 'Global'
        }
      ]
      if (this.tabs) {
        let vm = this
        for (let tab in this.tabs) {
          let scope = {
            value: tab,
            text: vm.tabs[tab].title
          }
          scopes.push(scope)
        }
      }
      return scopes
    }
  },
  methods: {
    update () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true
      this.$v.$reset()

      let vm = this
      let payload = {
        key: vm.key,
        name: vm.fileName,
        type: vm.type,
        scope: vm.selectedScope
      }

      db.customCode.updateMetaData(payload, (err) => {
        if (err) this.$store.commit('addError', err.message)
        if (this.$refs.customCodeModal) this.$refs.customCodeModal.hide()
        this.fileName = ''
        this.type = ''
        this.selectedScope = null
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.inProgress = false
      })
    }
  },
  created () {
    eventBus.$on('showCustomCodeUpdateModal', (key, type) => {
      this.key = key
      this.type = type

      if (this.customCode[type][key]) {
        this.fileName = this.customCode[type][key].name
        if (this.customCode[type][key].scope) this.selectedScope = this.customCode[type][key].scope
        else this.selectedScope = null
      }

      if (this.$refs.customCodeModal) {
        this.$refs.customCodeModal.show()
        setTimeout(() => {
          this.$refs.fileNameInput.focus()
        })
      }
    })

    db.tabs.read((tabs) => {
      this.tabs = tabs
    })

    db.customCode.read((data) => {
      this.customCode = data
    })
  },
  validations: {
    fileName: {
      required
    }
  },
  mounted () {
    if (this.$refs.customCodeModal) {
      $(this.$refs.customCodeModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.customCodeModal) {
      $(this.$refs.customCodeModal['$el']).remove()
    }
  }
}
</script>
